import $ from 'jquery';

const requiredFields = {
  Name: 'fromName',
  Email: 'fromEmail',
  Phone: 'message[Phone]',
  Body: 'message[body]',
};

function displayError(fieldName, errors) {
  const $input = $(`[name="${fieldName}"]`);
  const errorClass = 'error';
  const $ul = $('<ul class="js-errors"></ul>');

  $input.after($ul);
  $input.addClass(errorClass);

  errors.map((error) => {
    $ul.append(`<li>${error}</li>`);
    return $ul;
  });
}

function validate() {
  // eslint-disable-line
  const emailRegex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/; // eslint-disable-line
  const phoneRegex = /^\({0,1}((0|\+61)(2|4|3|7|8)){0,1}\){0,1}(\ |-){0,1}[0-9]{2}(\ |-){0,1}[0-9]{2}(\ |-){0,1}[0-9]{1}(\ |-){0,1}[0-9]{3}$/; // eslint-disable-line
  let pass = true;

  $('.js-errors').detach();
  $('.js-submit-success').empty();
  $('.js-submit-success').fadeOut();

  $.each(requiredFields, (field, fieldName) => {
    switch (fieldName) {
      case 'fromEmail':
        if (!emailRegex.test($(`[name="${fieldName}"]`).val())) {
          displayError(fieldName, ['Must be a valid email address.']);
          pass = false;
        }
        break;
      case 'message[Phone]':
        if ($(`[name="${fieldName}"]`).val() !== '') {
          if (!phoneRegex.test($(`[name="${fieldName}"]`).val())) {
            displayError(fieldName, ['Must be a valid phone number.']);
            pass = false;
          }
        }
        break;
      default:
        if ($(`[name="${fieldName}"]`).val() === '') {
          displayError(fieldName, [`${field} cannot be blank.`]);
          pass = false;
        }
    }
  });

  return pass;
}

function ajaxifyForms() {
  const $form = $('.js-ajax-form');

  $form.submit((event) => {
    event.preventDefault();

    if (!validate()) {
      return;
    }

    $.ajax('/', {
      data: $form.serialize(),
      dataType: 'json',
      method: 'post',
      success: (response) => {
        if (response.success) {
          const $success = $('.js-submit-success');
          $success.append($success.data('success-message'));
          $success.fadeIn();
          $form.fadeOut();
        } else {
          $.each(response.errors, (fieldName, errors) => {
            displayError(fieldName, errors);
          });
        }
      },
    });
  });
}

$(() => {
  ajaxifyForms();

  const onClass = 'on';
  const showClass = 'show';
  const errorClass = 'error';

  $('input, textarea')
    .on('checkval', function () {
      const $input = $(this);
      const $label = $input.prev('label');
      const $errors = $(this).next('.js-errors');

      if ($input.val() !== '') {
        $input.removeClass(errorClass);
        $label.addClass(showClass);
        $errors.detach();
      } else {
        $label.removeClass(showClass);
      }
    })
    .on('keyup', function () {
      $(this).trigger('checkval');
    })
    .on('focus', function () {
      $(this)
        .prev('label')
        .addClass(onClass);
    })
    .on('blur', function () {
      $(this)
        .prev('label')
        .removeClass(onClass);
    })
    .trigger('checkval');
});



// WEBPACK FOOTER //
// ./_components/contact-form/index.js